/**
 * ORDEM ALFABÉTICA — a "configuração" única de ordenação por nome do sistema.
 *
 * Mesmo critério da agenda do Planejamento (AgendaView): A→Z em português,
 * sem diferenciar maiúscula/minúscula nem acento ("Álcool" fica junto de
 * "Alicate", não depois do "Z"), e com números em ordem natural ("Cabo 2mm"
 * antes de "Cabo 10mm").
 *
 * A ordem é garantida NA TELA: não dependemos de a API devolver ordenado (o
 * ORDER BY do banco depende da collation, e o cadastro é dividido com o
 * Suprimentos). Use `ordenarPorNome` no ponto de exibição de toda lista de
 * pessoas ou de cadastros identificados por nome (itens, fornecedores...).
 *
 * NÃO use em listas cuja ordem natural é data/número (movimentações, termos,
 * solicitações, recebimentos, inventários) nem em rankings/criticidade
 * (alertas de estoque, top itens por valor).
 */

const OPCOES: Intl.CollatorOptions = { sensitivity: "base", numeric: true };

/** Compara dois nomes em ordem alfabética crescente (pt-BR). Vazio/nulo vira "". */
export const compararNomes = (a: unknown, b: unknown): number =>
  String(a ?? "").localeCompare(String(b ?? ""), "pt-BR", OPCOES);

/**
 * Devolve uma CÓPIA da lista em ordem alfabética pelo nome escolhido — a lista
 * original nunca é alterada (arrays usados por índice continuam intactos).
 * A ordenação é estável: empates mantêm a ordem em que chegaram.
 */
export function ordenarPorNome<T>(lista: readonly T[], nome: (item: T) => unknown): T[] {
  return [...lista].sort((a, b) => compararNomes(nome(a), nome(b)));
}

/**
 * Itens do estoque em ordem alfabética pela DESCRIÇÃO (é o "nome" do material);
 * mesma descrição desempata pelo código. Usado em todo select de item.
 */
export function ordenarItens<T extends { descricao?: unknown; codigo?: unknown }>(itens: readonly T[]): T[] {
  return [...itens].sort(
    (a, b) => compararNomes(a.descricao, b.descricao) || compararNomes(a.codigo, b.codigo),
  );
}
